module.exports = __webpack_public_path__ + "img/大图--水光.cb5d536a.png";